import { useMemo } from 'react'
import { arrayToMap, nonNullable } from 'lib/array/arrayUtils'
import useGlobalSearchVerticalTabHotels from './useGlobalSearchVerticalTabHotels'
import useGlobalSearchVerticalTabTours from './useGlobalSearchVerticalTabTours'
import useGlobalSearchVerticalTabExperiences from './useGlobalSearchVerticalTabExperiences'
import useGlobalSearchVerticalTabFlights from './useGlobalSearchVerticalTabFlights'
import useGlobalSearchVerticalTabCruises from './useGlobalSearchVerticalTabCruises'
import useGlobalSearchVerticalTabCarHire from './useGlobalSearchVerticalTabCarHire'
import useGlobalSearchVerticalTabHomesAndVillas from './useGlobalSearchVerticalTabHomesAndVillas'
import useGlobalSearchVerticalTabMerchandise from './useGlobalSearchVerticalTabMerchandise'
import useGlobalSearchVerticals from 'hooks/GlobalSearch/useGlobalSearchVerticals'

function useGlobalSearchVerticalTabsV2(): Map<App.SearchVertical, App.GlobalSearchVerticalTabV2> {
  // This gives us our central list of enabled search verticals and their order
  const searchVerticals = useGlobalSearchVerticals()

  // next, get all the v2 tab content
  const globalSearchVerticalTabHotels = useGlobalSearchVerticalTabHotels()
  const globalSearchVerticalTabHomesAndVillas = useGlobalSearchVerticalTabHomesAndVillas()
  const globalSearchVerticalTabTours = useGlobalSearchVerticalTabTours()
  const globalSearchVerticalTabExperiences = useGlobalSearchVerticalTabExperiences()
  const globalSearchVerticalTabFlights = useGlobalSearchVerticalTabFlights()
  const globalSearchVerticalTabCruises = useGlobalSearchVerticalTabCruises()
  const globalSearchVerticalTabCarHire = useGlobalSearchVerticalTabCarHire()
  const globalSearchVerticalTabMerchandise = useGlobalSearchVerticalTabMerchandise()

  const globalSearchVerticals = useMemo(() => {
    const v2TabMap = arrayToMap([
      globalSearchVerticalTabHotels,
      globalSearchVerticalTabHomesAndVillas,
      globalSearchVerticalTabTours,
      globalSearchVerticalTabCruises,
      globalSearchVerticalTabCarHire,
      globalSearchVerticalTabFlights,
      globalSearchVerticalTabExperiences,
      globalSearchVerticalTabMerchandise,
    ], tab => tab.key)

    const enabledTabs = nonNullable(searchVerticals.map(searchType => v2TabMap.get(searchType.vertical)))

    return arrayToMap(enabledTabs, tab => tab.key)
  }, [
    searchVerticals,
    globalSearchVerticalTabHotels,
    globalSearchVerticalTabHomesAndVillas,
    globalSearchVerticalTabTours,
    globalSearchVerticalTabExperiences,
    globalSearchVerticalTabFlights,
    globalSearchVerticalTabCruises,
    globalSearchVerticalTabCarHire,
    globalSearchVerticalTabMerchandise,
  ])

  return globalSearchVerticals
}

export default useGlobalSearchVerticalTabsV2
